export { default } from 'cccisd-game-fireandice';
